import { Component, Input, Output, EventEmitter, ViewChild, OnDestroy } from '@angular/core';
import { MatSelect, MAT_SELECT_CONFIG } from '@angular/material/select';
import { TranslateService } from '@ngx-translate/core';
import { Utils } from '../../services/utils.service';
import { SessionService } from '../../services/session.service';

import { SHARED_MODULES } from '../../../shared.';
import { FilterCallbackPipe } from '../../pipes/filter-callback.pipe';
import { SearchComponent } from '../search/search.component';

@Component({
	selector: 'app-autocomplete',
	templateUrl: './autocomplete.component.html',
	styleUrls: ['./autocomplete.component.scss'],
	imports: [SHARED_MODULES, FilterCallbackPipe, SearchComponent],
	providers: [
		{ provide: MAT_SELECT_CONFIG, useValue: { overlayPanelClass: 'autocomplete' } }
	],
	standalone: true
})
export class AutocompleteComponent implements OnDestroy {

	@Input() value: number = -1;
	@Input() selectStyle: string = '';
	@Input() hideSearch: boolean = false;
	@Input() changeWidth: boolean = false;
	@Input() navigationFilter: boolean = false;
	@Input() sort: boolean = true;
	@Input() changeStyle: boolean = false;
	@Input() hideUnderline: boolean = false;
	@Input() panelClass: string = '';
	@Input() fullWidth: boolean = false;
	@Input('options') set setOptions(list: any[]) {
		if (!list || !list.length) return;
		this.options = list;
		const val = this.options.findIndex((v) => v.active);
		if (~this.initialValue && this.initialValue) {
			this.value = this.initialValue;
		} else {
			this.value = this.sort
				? this.options[val != -1 ? val : 0].id
				: this.options[0].id;
		}
		this.options.forEach((i) => (i.active = i.id == this.value));
	}
	@Input('initial_value') set setInitialValue(value) {
		if (value) this.initialValue = value;
	}

	@Output('change') cancelEvent: EventEmitter<number> = new EventEmitter<number>();

    @ViewChild(MatSelect) select: MatSelect;

    initialValue: number = null;
    options: any[];
    inputFilter: string = '';
    langChangeSubscription: any;

	constructor(
		private translate: TranslateService,
		private sessionService: SessionService
	) {
		this.langChangeSubscription = this.translate.onLangChange.subscribe(() => {
			const value = this.value;
			this.value = null;

			setTimeout(() => (this.value = value));
		});
	}

	filterItems(item: any): boolean {
		if (item.id === this.value) return true;
		return Utils.searchItem(
			item,
			['name'],
			this.inputFilter,
			this.sessionService.personalSettings.searchAlgorithm
		);
	}

	onChange(value) {
		this.cancelEvent.emit(value.value);
		this.inputFilter = '';
	}

	onOpenedChange(isOpened: boolean): void {
		if (!isOpened) this.inputFilter = '';
	}

	ngOnDestroy() {
		this.langChangeSubscription.unsubscribe();
	}
}
